const BASE_REST_URL = '/rest';
const FAMILY_HOMES_HQ_TIMEZONE = 'Asia/Kathmandu';

export { BASE_REST_URL, FAMILY_HOMES_HQ_TIMEZONE };
